import { Building2, LogIn, ShieldCheck } from 'lucide-react';
import { useState } from 'react';

import { useAuth } from './AuthProvider';

export function SignIn() {
  const { signIn, authError } = useAuth();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handle() {
    setBusy(true);
    setError('');
    try {
      await signIn();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink-950 px-4">
      <div className="card w-full max-w-md p-8">
        <div className="mb-6 flex items-center gap-3">
          <div className="grid h-11 w-11 place-items-center rounded-xl bg-accent-soft/15 text-accent">
            <Building2 size={22} />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-slate-100">Tax Intake Console</h1>
            <p className="text-sm text-slate-400">Harris County tax-suit pipeline</p>
          </div>
        </div>
        <p className="mb-6 text-sm leading-relaxed text-slate-400">
          Sign in with your team Google account to review tax suits, run the data sources, and push
          records to GetLeverage.
        </p>
        <button type="button" className="btn-primary w-full" onClick={handle} disabled={busy}>
          <LogIn size={16} />
          {busy ? 'Signing in…' : 'Sign in with Google'}
        </button>
        {(error || authError) && <p className="mt-4 text-sm text-rose-400">{error || authError}</p>}
        <p className="mt-6 flex items-center gap-1.5 text-xs text-slate-500">
          <ShieldCheck size={13} /> Access is restricted to allowlisted team accounts.
        </p>
      </div>
    </div>
  );
}
